"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _useUploadDocument.default;
  }
});

var _useUploadDocument = _interopRequireDefault(require("./useUploadDocument"));

var _useUploadDocument2 = require("./useUploadDocument.types");

Object.keys(_useUploadDocument2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useUploadDocument2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useUploadDocument2[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9ob29rcy91c2VVcGxvYWREb2N1bWVudC9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgZGVmYXVsdCB9IGZyb20gJy4vdXNlVXBsb2FkRG9jdW1lbnQnO1xuZXhwb3J0ICogZnJvbSAnLi91c2VVcGxvYWREb2N1bWVudC50eXBlcyc7XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/securedocuments-sdk-js/dist/react/hooks/useUploadDocument/index.js
// module id = 1830
// module chunks = 0